import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {ArrowDown, Edit3, Plus, PlusCircle, Trash2} from "react-feather"
import {ReactSortable} from "react-sortablejs";
import React, {useState} from "react";
import dots from "../../../assets/dots.png";
import {fixFooterButtons} from "../../components/FooterButtons";
import axios from "axios";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import DodajEkipeGrupuModal from "./DodajEkipeGrupuModal";
import KontaktiModal from "../../upravljanje/Sastavnice/KontaktiModal";

const MySwal = withReactContent(Swal)

const LeagueScreen = (props) => {

    const [modalVisible, setModalVisible] = useState(false);
    const [index, setIndex] = useState(false);
    if (props.isLoading === true) {
        return null;
    }
    let showScoreTable = !props.setGroups;
    return (
        <Row>
            <DodajEkipeGrupuModal
                chosenGroupIndex={index}
                groups={props.groups}
                setGroups={props.setGroups}
                toggle={() => {
                    setModalVisible(!modalVisible);
                }}
                isOpen={modalVisible}
                allTeams={props.allTeams}
                setAllTeams={props.setAllTeams}
            />
            {props.groups && props.groups.map((group, index) => {
                let teams = group.teams;
                let setTeams = (newTeams) => {
                    if (!props.setGroups || !group.isNewGroup) {
                        return;
                    }
                    let newGroups = props.groups;
                    newGroups[index].teams = newTeams;
                    props.setGroups([...newGroups])
                    fixFooterButtons();
                }
                return (
                    <Col>
                        <Card style={{margin: "15px"}}>
                            <div style={{
                                width: "290px",
                                backgroundColor: "whitesmoke",
                                boxShadow: "1px 1px 7px grey",
                                borderRadius: "6px"
                            }}>
                                <div style={{width: "97%", margin: "3px auto"}}>
                                    <CardHeader className={"justify-content-center"}>
                                        <h4
                                            style={{
                                                cursor: "pointer"
                                            }}
                                            onClick={() => {
                                                setIndex(index)
                                                setModalVisible(true)
                                            }}>{group.name} <PlusCircle style={{
                                            marginLeft: "30px"
                                        }} size={10}/></h4>
                                        <span
                                            style={{
                                                cursor: "pointer",
                                                position: "absolute",
                                                top: "40%",
                                                right: "0%",
                                                padding: "12px 16px",
                                                transform: "translate(0%, -50%)"
                                            }}
                                        >
                                            {!group.isNewGroup &&
                                            <Trash2
                                                size={14}
                                                style={{
                                                    marginLeft: "15px",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                    MySwal.fire({
                                                        title: 'Jeste li sigurni',
                                                        text: "Klikom na gumb Izbriši grupa će biti izbrisana",
                                                        icon: 'warning',
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Izbriši',
                                                        cancelButtonText: "Odustani",
                                                        customClass: {
                                                            confirmButton: 'btn btn-primary',
                                                            cancelButton: 'btn btn-outline-danger ml-1'
                                                        },
                                                        buttonsStyling: false
                                                    }).then((result) => {
                                                        if (result.value) {
                                                            axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/delete-group`, {
                                                                name: group.name,
                                                                leagueId: props.currentPhase.league._id
                                                            }).then((result) => {
                                                                MySwal.fire({
                                                                    icon: 'success',
                                                                    title: 'Uspješno',
                                                                    text: 'Uspješno izbrisana grupa',
                                                                    customClass: {
                                                                        confirmButton: 'btn btn-success'
                                                                    }
                                                                }).then(() => {
                                                                    window.location.reload();
                                                                })

                                                            }).catch((e) => {
                                                                if (e.response && e.response.data && e.response.data.message) {
                                                                    window.alert(e.response.data.message);
                                                                } else {
                                                                    window.alert("Nesto je poslo po krivu. Molimo probajte ponovno.")
                                                                }
                                                            })
                                                        }
                                                    })
                                                }}
                                            />
                                            }
                                    </span>
                                    </CardHeader>
                                    <CardBody>
                                        <ReactSortable
                                            className='list-group sortable'
                                            multiDrag={group.isNewGroup}
                                            group='shared-multi-drag-group'
                                            disabled={!group.isNewGroup}
                                            list={teams}
                                            setList={setTeams}
                                            style={group.isNewGroup ? {
                                                border: "2px dashed grey",
                                                minHeight: "100px"
                                            } : null}
                                        >
                                            {teams && teams.map((team) => {
                                                if (!team) {
                                                    return null;
                                                }
                                                return (
                                                    <div key={team._id ? team._id : "someting"} style={{
                                                        backgroundColor: "white",
                                                        borderRadius: "6px",

                                                        margin: "5px",
                                                        marginLeft: "20px",
                                                        marginRight: "20px",
                                                        marginBottom: "20px",
                                                        height: "35px"
                                                    }}
                                                         className={"row justify-content-center align-content-center"}>
                                                        {!showScoreTable && !!group.isNewGroup &&
                                                        <Col md='2'>
                                                            <img style={{
                                                                width: "12px",
                                                                height: "12px"
                                                            }} className={"my-auto"} src={dots}/>
                                                        </Col>
                                                        }
                                                        <Col md={"10"}>
                                                            {team &&
                                                            <span> {team.shortName ? team.shortName : (team.name ? team.name : team)} {team.surname ? team.surname : ""}</span>
                                                            }
                                                            {!team &&
                                                            <span></span>
                                                            }
                                                        </Col>

                                                    </div>
                                                );
                                            })}
                                        </ReactSortable>
                                    </CardBody>
                                </div>
                            </div>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
}

export default LeagueScreen;